import { useCallback, useEffect, useMemo } from 'react';

import { Selector, useDispatch, useSelector } from 'react-redux';

import { AppState } from '../../store/appState';
import { fetchCopiesForProduct, removeCopy } from '../../store/copiesList/actions';
import { AppDispatch } from '../../store';
import { UsageCondition } from '../../../models/Product';

type Options = {
    // TODO: add proper typing for product
    readonly product: any;
    readonly usageCondition?: UsageCondition;
};

type UseCopiesList = {
    // TODO: add proper typing for copies list elements
    readonly copies: ReadonlyArray<any>;
    readonly loading: boolean;
    readonly removeCopyById: (copyId: number) => Promise<void>;
};

export function useCopiesList({ product, usageCondition }: Options): UseCopiesList {
    const { id: productId } = product;

    const dispatch = useDispatch<AppDispatch>();
    const copies = useSelector(selectCopiesByProductId(productId));
    const loading = useSelector(selectCopiesLoading);
    const numberOfCopies = copies.length;

    useEffect(() => {
        if (numberOfCopies === 0) {
            dispatch(fetchCopiesForProduct(productId));
        }
    }, [dispatch, productId, numberOfCopies]);

    const filteredCopies = useMemo(() => copies.filter(hasUsageCondition(usageCondition)), [copies, usageCondition]);

    const removeCopyById = useCallback(copyId => dispatch(removeCopy(productId, copyId)), [dispatch, productId]);

    return {
        copies: filteredCopies,
        loading,
        removeCopyById
    };
}

// TODO: it seems the AppState typings are erroneous, fix the typings and then use AppState here
function selectCopiesByProductId(productId: string): Selector<any, ReadonlyArray<any>> {
    return state => (state.copiesList.lists?.[productId] ? state.copiesList.lists?.[productId]?.list : []);
}

const selectCopiesLoading: Selector<AppState, boolean> = state => {
    return !!state.copiesList.loading;
};

function hasUsageCondition(usageCondition: UsageCondition | undefined) {
    if (!usageCondition) {
        return () => true;
    }

    return ({ price }) => {
        return (
            usageCondition.lendingModel === price.lendingModel &&
            usageCondition.usageLimit === price.usageLimit &&
            usageCondition.termLimit === price.termLimit
        );
    };
}
